import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="enum-field-validator-form"
export default class extends Controller {
  static targets = [
    "table",
  ]

  connect() {
    // Relies on an empty option being added
    const templateElement = this.tableTarget.querySelector("tr:last-of-type");
    templateElement.remove();
    const input = templateElement.querySelector("input[type=text]")
    input.id = ""
    this.nextIndex = parseInt(input.dataset.index, 0);
    this.templateHTML = templateElement.outerHTML
  }

  add(event) {
    event.preventDefault();

    // Each element we have must have a unique "index" in its `name`, which has the form
    //   name="mapped_fields[enum_options_attributes][<index here>][name]"
    let html = this.templateHTML.replace(/\[\d+\]/, `[${this.nextIndex}]`);
    this.tableTarget.insertAdjacentHTML("beforeend", html);

    ++this.nextIndex;
  }

  remove(event) {
    event.preventDefault();

    let parent = event.currentTarget.closest("tr");
    parent.querySelector("input[name*=_destroy]").value = "1";
    parent.style.display = "none";
  }
}
